import React, {useEffect, useState} from 'react'
import {Link, useHistory, useParams} from "react-router-dom"
import {useForm, Controller, ErrorMessage} from 'react-hook-form'
import { useAlert } from 'react-alert'

import "react-datepicker/dist/react-datepicker.css"
import {getRegistration, postRegistration, putRegistration} from "../../api";
import useApi from "../../useApi";
import InputMask from 'react-input-mask'
import MobileFooter from "../../components/Footer/MobileFooter";
import * as yup from 'yup'
import SectionAside from "../../components/SectionAside";
import {useQuery} from "../../useQuery";

function calculateAge(birthday) {
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

const RegistrationSchema = yup.object().shape({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    email: yup.string().email().required(),
    birthday: yup.string().test(('Bithday Test', 'Members of The Room are required to be over the age of 18. If you have any questions concerning this, please email membership@theroom.com', val => {
        let dt = stringToDate(val);
        if (!dt.getFullYear()) return false;
        if (dt.getFullYear() > 2010) return false;
        if (dt.getFullYear() < 1910) return false;

        let age = calculateAge(dt);
        if (age < 18) return false;

        return true;
    })).required(),
});

const stringToDate = (str) => {
    let parts = str.split("/");

    let year = parseInt(parts[2], 10);
    let month = parseInt(parts[1], 10) - 1;
    let day = parseInt(parts[0], 10);

    if (day > 31) return new Date();
    if (month >= 12) return new Date();

    let dt = new Date(year, month, day);

    let userTimezoneOffset = dt.getTimezoneOffset() * 60000;
    dt = new Date(dt.getTime() - userTimezoneOffset);

    return dt;
};

const dateToString = (date) => {

    if (!date) return "";

    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [day, month, year].join('/');
};

export default function Apply() {
    const history = useHistory();
    const {key} = useParams();
    const [isAgree, setIsAgree] = useState(false);
    const {register, reset, handleSubmit, errors, control} = useForm({validationSchema: RegistrationSchema});
    const alert = useAlert();
    const [{data}, get] = useApi({alert});
    const [{data: doc}, update] = useApi({alert});
    const query = useQuery();
    const isAlumni = query.get("alumni");

    useEffect(() => {
        if (key)
            get(getRegistration(key))
    }, [key, get]);

    useEffect(() => {
        if (doc.id)
            history.push(`/apply/membership/${doc.id}`);
    }, [doc, history]);

    useEffect(() => {
        if (data && data.birthday) {
            let date = new Date(data.birthday);
            reset({birthday: dateToString(date)})
        }
    }, [data]);

    const onSubmit = async (formData) => {
        let body = {
            ...formData,
            birthday: stringToDate(formData.birthday),
            isAlumni: isAlumni == "true"
        };
        data.id ? update(putRegistration({...body, id: data.id}))
            : update(postRegistration(body));
    };

    const getFieldClassName = (err) => {
        return `field${err ? " field--error" : ""}`;
    };

    return (
        <section className="section-form">
            <div className="section__outer">

                <SectionAside/>

                <div className="section__content">

                    <ErrorMessage errors={errors} name="birthday">
                        {({message}) => (
                            <div className="bar section__bar">
                                <div className="bar__content">
                                    <p>Members of The Room are required to be over the age of 18. If you have any
                                        questions concerning this, please email membership@theroom.com</p>
                                </div>
                            </div>
                        )}
                    </ErrorMessage>

                    <div className="section__content-inner">
                        <div className="form">
                            <div className="form__inner">
                                <h2 className="form__title">Become a Member</h2>
                                <div className="form__body">
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="form__row">
                                            <label htmlFor="firstName" className="form__label">First Name</label>
                                            <div className="form__controls">
                                                <input className={getFieldClassName(errors.firstName)}
                                                       id="firstName" name="firstName"
                                                       ref={register} defaultValue={data.firstName}/>
                                            </div>
                                        </div>

                                        <div className="form__row">
                                            <label htmlFor="lastName" className="form__label">Surname</label>
                                            <div className="form__controls">
                                                <input type="text" className={getFieldClassName(errors.lastName)}
                                                       id="lastName" name="lastName"
                                                       ref={register} defaultValue={data.lastName}/>
                                            </div>
                                        </div>

                                        <div className="form__row">
                                            <label htmlFor="email" className="form__label">Email</label>
                                            <div className="form__controls">
                                                <input type="email" className={getFieldClassName(errors.email)}
                                                       id="email" name="email"
                                                       ref={register} defaultValue={data.email}/>
                                            </div>
                                        </div>

                                        <div className="form__row">
                                            <label htmlFor="birthday" className="form__label">Birthday
                                                (dd/mm/yyyy)</label>
                                            <div className="form__controls">
                                                <Controller name="birthday"
                                                            as={<InputMask
                                                                id="birthday"
                                                                className={getFieldClassName(errors.birthday)}
                                                                placeholder=""
                                                                mask="99/99/9999"
                                                            />} control={control}
                                                            defaultValue={dateToString(data.birthday)}/>
                                            </div>
                                        </div>

                                        <div className="form__row form__row--spaced">
                                            <div className="form__controls">
                                                <div className="checkbox-alt">
                                                    <input id="checkbox-1" type="checkbox"
                                                           checked={isAgree}
                                                           onChange={(e) => setIsAgree(e.target.checked)}/>
                                                    <label htmlFor="checkbox-1">
                                                        I acknowledge that I have read and agree to the
                                                    </label>
                                                    &nbsp;
                                                    <Link to="/terms" target="_blank">Terms and
                                                        Conditions</Link> and <Link to="/privacy" target="_blank">Privacy
                                                    Policy</Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__actions">
                                            <button
                                                disabled={!isAgree}
                                                type="submit" className={"btn__form"}
                                                style={!isAgree ? {backgroundColor: "#D1CBC4"} : {}}>NEXT
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <MobileFooter/>
                    </div>
                </div>
            </div>
        </section>
    )
}